import { useOKRequest } from '../hooks';
import { debounce } from 'lodash';
import { useState, useEffect, useCallback } from 'react';

export default function useScrollOKRequest(servicer, { scrollDomRef, ...options } = {}, ...opts) {
  const requestData = useOKRequest(servicer, options, opts)
  const [pageNo, setPageNo] = useState(0)
  const [params, setParams] = useState({
    pageSize: 3,
    ...options.defaultParams,
  })
  const [reduceData, setReduceData] = useState([])

  // 监听滚动事件
  useEffect(() => {
    // 监听某个元素的滚动事件
    var scrollableElement = document.getElementById(scrollDomRef);
    if (!scrollableElement) return
    scrollableElement.addEventListener('scroll', function () {
      // console.log('元素滚动了', scrollableElement);
      // console.log('scrollTop', scrollableElement.scrollTop);
      // console.log('clientHeight', scrollableElement.clientHeight);
      // console.log('scrollHeight', scrollableElement.scrollHeight);
      const isScrolledToBottom = (Math.ceil(scrollableElement.scrollTop) + scrollableElement.clientHeight) >= scrollableElement.scrollHeight;
      console.log('isScrolledToBottom', isScrolledToBottom)
      if (!isScrolledToBottom) {
        return;
      }
      // console.log('requestData.loading', requestData.loading)
      requestData.loading || requestData.runAsync({
        ...params,
        pageNo,
      }).then((res) => {
        setReduceData([...reduceData, ...(res.data.result.records || [])])
      })
      setPageNo(pageNo + 1);
    });
    // if (requestData.data?.data?.result?.total) {
    //   console.log('requestData.data.data.result.total', requestData.data.data.result.total)
    //   console.log('pageNo', pageNo)
    //   console.log('params.pageSize', params.pageSize)
    // }
    if (requestData.data?.data?.result?.total && pageNo * params.pageSize >= requestData.data.data.result.total) {
      return
    }
    const handleScroll1 = () => {
      console.log('元素滚动了', scrollableElement);
      console.log('scrollTop', scrollableElement.scrollTop);
      console.log('clientHeight', scrollableElement.clientHeight);
      console.log('scrollHeight', scrollableElement.scrollHeight);
      const isScrolledToBottom = (Math.ceil(scrollableElement.scrollTop) + scrollableElement.clientHeight) >= scrollableElement.scrollHeight;
      console.log('isScrolledToBottom', isScrolledToBottom)
      if (!isScrolledToBottom) {
        return;
      }
      // console.log('requestData.loading', requestData.loading)
      requestData.loading || requestData.runAsync({
        ...params,
        pageNo,
      }).then((res) => {
        setReduceData([...reduceData, ...(res.data.result.records || [])])
      })
      setPageNo(pageNo + 1);
    }

    // if (!scrollDomRef.current) return
    // if (requestData.data?.data?.result?.total && pageNo * params.pageSize >= requestData.data.data.result.total) {
    //   return
    // }

    // const element = scrollDomRef.current
    // const handleScroll = debounce(() => {
    //   const isScrolledToBottom = (Math.ceil(element.scrollTop) + element.clientHeight) >= element.scrollHeight;
    //   console.log('isScrolledToBottom', isScrolledToBottom)
    //   if (!isScrolledToBottom) {
    //     return;
    //   }
    //   // console.log('requestData.loading', requestData.loading)
    //   requestData.loading || requestData.runAsync({
    //     ...params,
    //     pageNo,
    //   }).then((res) => {
    //     setReduceData([...reduceData, ...(res.data.result.records || [])])
    //   })
    //   setPageNo(pageNo + 1);
    // }, 50)

    // scrollDomRef.current.addEventListener('scroll', handleScroll);
    // scrollableElement.addEventListener('scroll', handleScroll1);

    return () => {
      // scrollDomRef.current.removeEventListener('scroll', handleScroll);
      // scrollableElement.removeEventListener('scroll', handleScroll1);
    };
  }, [pageNo, params, requestData.loading, scrollDomRef.current]);

  const resetRun = useCallback((params) => {
    setPageNo(params.pageNo + 1)
    setParams(params)
    // console.log(params)
    requestData.runAsync(params).then((res) => {
      setReduceData(res.data.result.records || [])
    })
  }, [requestData.runAsync])

  return {
    ...requestData,
    data: reduceData,
    run: resetRun,
  }
}
